import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonWebService, UserHttpService, UserType } from '../../../utils/public-api';

@Component({
  selector: 'intrasense-all-errors',
  templateUrl: './all-errors.component.html',
  styleUrls: ['./all-errors.component.scss']
})
export class AllErrorsComponent implements OnInit {
  title!: string | number;
  description!: string;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loginService: CommonWebService,
    private userService: UserHttpService
  ) { }

  ngOnInit(): void {
    if(this.route.snapshot.paramMap.get('code')) {
      let errorCode = Number(this.route.snapshot.paramMap.get('code'));
      if(typeof errorCode == 'number') {
        if(errorCode == 500 || errorCode == 501 || errorCode == 301 || errorCode == 403 || errorCode == 401) {
          this.title = errorCode;
          if(errorCode == 401) {
            this.description = "You don't have permission, <br/> To view the page using the login credentials that you have supplied";
          } else {
            this.description = "We're sorry, <br/> The page you were looking for doesn't exist anymore";
          }
        } else {
          this.title = "Error!";
        }
      } else {
        this.title = "Error!";
      }
    }
  }

  navigateTo(event: boolean) {
    if(event) {
      if(this.title == 401) {
        this.loginService.logout();
      } else {
        if(this.userService.getUserInfo && this.userService.getUserInfo.user_id) {
          this.userService.getUserInfo.user_type == UserType.VENDOR ? this.router.navigate(['/user/manage-orders/rfq']) : this.router.navigate(['/user/clients']);
        } else {
          this.loginService.logout();
        }
      }
    } else {
      this.loginService.logout();
    }
  }

}
